import { useState } from "react";
import { is, curryN, gte } from "ramda";
import {
  graphDataLimit,
  ToolTypes,
  offlineTime,
  timeFormats,
  dateFormats,
  months,
} from "../global";
import {
  THP_GRAPH_CONVERSION,
  THP_CH_ENUM,
  THP_DEFAULT_Y_AXIS,
} from "../Tools/THP";
import {
  SDP1_GRAPH_CONVERSION,
  SDP1_CH_ENUM,
  SDP1_DEFAULT_Y_AXIS,
} from "../Tools/SDP1";
import {
  ST4C_GRAPH_CONVERSION,
  ST4C_CH_ENUM,
  ST4C_DEFAULT_Y_AXIS,
} from "../Tools/ST4C";
import {
  SA4C_GRAPH_CONVERSION,
  SA4C_CH_ENUM,
  SA4C_DEFAULT_Y_AXIS,
} from "../Tools/SA4C";
import {
  SSS1_GRAPH_CONVERSION,
  SSS1_CH_ENUM,
  SSS1_DEFAULT_Y_AXIS,
} from "../Tools/SSS1";
import {
  SCP1_GRAPH_CONVERSION,
  SCP1_CH_ENUM,
  SCP1_DEFAULT_Y_AXIS,
} from "../Tools/SCP1";
// import { store } from "App/App";
import _ from "lodash";

const isWithin = curryN(3, (min, max, value) => {
  const isNumber = is(Number);
  return (
    isNumber(min) &&
    isNumber(max) &&
    isNumber(value) &&
    gte(value, min) &&
    gte(max, value)
  );
});
const in200s = isWithin(200, 299);

function useMergeState(initialState) {
  const [state, setState] = useState(initialState);
  const setMergedState = (newState) =>
    setState((prevState) => Object.assign({}, prevState, newState));
  return [state, setMergedState];
}

function getEpoch(value) {
  console.log("getEpoch value:", value);
  return Math.floor(value.getTime() / 1000);
}

function convertData(tool, data, attributeArray) {
  console.log("CONVERT DATA:", data);
  if (tool.toolType == ToolTypes.THP) {
    return THP_GRAPH_CONVERSION(tool, data, attributeArray);
  } else if (tool.toolType == ToolTypes.SDP) {
    return SDP1_GRAPH_CONVERSION(tool, data, attributeArray);
  } else if (tool.toolType == ToolTypes.ANALOG_4_CH) {
    return SA4C_GRAPH_CONVERSION(tool, data, attributeArray);
  } else if (tool.toolType == ToolTypes.THERMO_4_CH) {
    return ST4C_GRAPH_CONVERSION(tool, data, attributeArray);
  } else if (tool.toolType == ToolTypes.SWIM) {
    return SSS1_GRAPH_CONVERSION(tool, data, attributeArray);
  } else if (tool.toolType == ToolTypes.CHEM) {
    return SCP1_GRAPH_CONVERSION(tool, data, attributeArray);
  }
  return;
}

function limitData(data) {
  // let returnData = _.cloneDeep(data)
  // data.forEach((attribute,index) => {
  //     if(attribute.data.length>graphDataLimit){
  //         console.log("Previous size:",attribute.data.length)
  //         let newData = []
  //         let indexMultiplier = attribute.data.length / graphDataLimit
  //         for(let i=0;i<graphDataLimit;i++){
  //             newData.push(attribute.data[Math.floor(i*indexMultiplier)])
  //         }
  //         returnData[index].data = newData
  //     }
  // });
  // return returnData
  if (data.length > graphDataLimit) {
    console.log("Previous size:", data.length);
    let newData = [];
    let indexMultiplier = data.length / graphDataLimit;
    for (let i = 0; i < graphDataLimit; i++) {
      newData.push(data[Math.floor(i * indexMultiplier)]);
    }
    return newData;
  } else {
    return data;
  }
}

function normalizeData(
  toolType,
  settings,
  data,
  tsIdx,
  attributeArray,
  maxValues,
  minValues,
  manifestSettings,
  sharedSettings
) {
  let defaultEnAxis;
  if (settings?.graphPropsDashboard?.enY == undefined) {
    if (!ToolTypes.THP.localeCompare(toolType)) {
      defaultEnAxis = THP_DEFAULT_Y_AXIS(
        manifestSettings
          ? manifestSettings.channels
          : sharedSettings
          ? sharedSettings.channels
          : settings.channels
      );
    } else if (!ToolTypes.SDP.localeCompare(toolType)) {
      defaultEnAxis = SDP1_DEFAULT_Y_AXIS(
        manifestSettings
          ? manifestSettings.channels
          : sharedSettings
          ? sharedSettings.channels
          : settings.channels
      );
    } else if (!ToolTypes.THERMO_4_CH.localeCompare(toolType)) {
      defaultEnAxis = ST4C_DEFAULT_Y_AXIS(
        manifestSettings
          ? manifestSettings.channels
          : sharedSettings
          ? sharedSettings.channels
          : settings.channels
      );
    } else if (!ToolTypes.ANALOG_4_CH.localeCompare(toolType)) {
      defaultEnAxis = SA4C_DEFAULT_Y_AXIS(
        manifestSettings
          ? manifestSettings.channels
          : sharedSettings
          ? sharedSettings.channels
          : settings.channels
      );
    } else if (!ToolTypes.SWIM.localeCompare(toolType)) {
      defaultEnAxis = SSS1_DEFAULT_Y_AXIS;
    } else if (!ToolTypes.CHEM.localeCompare(toolType)) {
      defaultEnAxis = SCP1_DEFAULT_Y_AXIS(
        manifestSettings
          ? manifestSettings
          : sharedSettings
          ? sharedSettings
          : settings
      );
    }
  }

  let normalizedData = data;
  if (normalizedData.length > 1) {
    let TOOL_CH_ENUM = [];
    switch (toolType) {
      case ToolTypes.THP:
        TOOL_CH_ENUM = THP_CH_ENUM;
        break;
      case ToolTypes.SDP:
        TOOL_CH_ENUM = SDP1_CH_ENUM;
        break;
      case ToolTypes.ANALOG_4_CH:
        TOOL_CH_ENUM = SA4C_CH_ENUM;
        break;
      case ToolTypes.THERMO_4_CH:
        TOOL_CH_ENUM = ST4C_CH_ENUM;
        break;
      case ToolTypes.SWIM:
        TOOL_CH_ENUM = SSS1_CH_ENUM;
        break;
      case ToolTypes.CHEM:
        TOOL_CH_ENUM = SCP1_CH_ENUM;
        break;
      default:
        break;
    }
    let minArray = [];
    let maxArray = [];
    let curAxis;
    let min;
    let max;
    attributeArray.forEach((attribute, index) => {
      curAxis = settings?.graphPropsDashboard?.enY
        ? settings.graphPropsDashboard.enY.find((axis) => {
            if (axis)
              return (
                axis.channels.find(
                  (channel) =>
                    channel ==
                    _.findIndex(TOOL_CH_ENUM, function (o) {
                      return o == attributeArray[index];
                    })
                ) != undefined
              );
            return null;
          })
        : defaultEnAxis.find((axis) => {
            if (axis)
              return (
                axis.channels.find(
                  (channel) =>
                    channel ==
                    _.findIndex(TOOL_CH_ENUM, function (o) {
                      return o == attributeArray[index];
                    })
                ) != undefined
              );
            return null;
          });
      if (index != tsIdx && curAxis) {
        if (curAxis.auto) {
          min = Math.min(
            ...curAxis.channels.reduce(
              (prev, cur) =>
                prev.concat(
                  minValues[
                    _.findIndex(attributeArray, function (o) {
                      return o == TOOL_CH_ENUM[cur];
                    })
                  ]
                ),
              []
            )
          );
          max = Math.max(
            ...curAxis.channels.reduce(
              (prev, cur) =>
                prev.concat(
                  maxValues[
                    _.findIndex(attributeArray, function (o) {
                      return o == TOOL_CH_ENUM[cur];
                    })
                  ]
                ),
              []
            )
          );
          minArray.push(min);
          maxArray.push(max);
        } else {
          minArray.push(curAxis.min);
          maxArray.push(curAxis.max);
        }
      } else {
        minArray.push(0);
        maxArray.push(0);
      }
    });
    try {
      normalizedData = data.map((i) =>
        i.map((j, index) => {
          if (index != tsIdx) {
            if (maxArray[index] != minArray[index]) {
              return index != tsIdx && !isNaN(j) && j != null
                ? (j - minArray[index]) / (maxArray[index] - minArray[index])
                : j;
            }
            return index != tsIdx ? null : j;
          } else {
            return j;
          }
        })
      );
    } catch (error) {
      console.error(error);
    }
  }

  return normalizedData;
}

function maxMin(data, tsIdx) {
  if (data.length > 1) {
    let maxValues = new Array(data[0].length);
    let minValues = new Array(data[0].length);
    maxValues[tsIdx] = 0;
    minValues[tsIdx] = 0;
    //Get Max/Min
    data.forEach((entry) => {
      entry.forEach((attribute, index) => {
        if (index != tsIdx) {
          //MAX
          if (maxValues[index] == undefined) {
            maxValues[index] = attribute;
          } else {
            if (attribute > maxValues[index]) {
              if (attribute != null) maxValues[index] = attribute;
            }
          }
          //MIN
          if (minValues[index] == undefined) {
            minValues[index] = attribute;
          } else {
            if (attribute < minValues[index]) {
              if (attribute != null) minValues[index] = attribute;
            }
          }
        }
      });
    });
    return [maxValues, minValues];
  }
  return [[undefined], [undefined]];
}

function compareMaps(map1, map2) {
  var testVal;
  if (map1 == null || map2 == null) return false;
  if (map1.size !== map2.size) {
    return false;
  }
  for (var [key, val] of map1) {
    testVal = map2.get(key);
    // in cases of an undefined value, make sure the key
    // actually exists on the object so there are no false positives
    if (!_.isEqual(testVal, val) || (testVal === undefined && !map2.has(key))) {
      return false;
    }
  }
  return true;
}

function isCloudConnected(nextUpdateTS) {
  //nextUpdateTS not updating properly
  let now = getEpoch(new Date());
  if (nextUpdateTS == 9999999999) return false; //Network Loss Detected
  if (now < nextUpdateTS + offlineTime) {
    //
    return true;
  }
  return false;
}

function isLeapYear(year) {
  let leapYear = false;
  let div4 = year % 4 == 0;
  let div100 = year % 100 == 0;
  let div400 = year % 400 == 0;
  if (div4) leapYear = true;
  if (div100) {
    if (div400) {
      leapYear = true;
    } else {
      leapYear = false;
    }
  }
  return leapYear;
}

/**
 *@Summary Formats Time and returns as a string
 *
 * @param curTime the time to format
 * @param format - Determine the info to be included in the formatted string. 0 - HH:MM, 1 - HH:MM:SS, 2 - HH
 * @param graph - Is this time stamp for graph labels?
 *
 * @return formatted string
 * */
function formatTime(curTime, format, graph) {
  let timeFormat; //= store.getState().userStore.settings.appearance.timeFormat
  if (timeFormat == undefined) timeFormat = timeFormats[0];
  let hours = curTime.getHours();
  //AM/PM
  let meridiem = hours >= 12 ? "PM" : "AM";
  let minutes = curTime.getMinutes();
  minutes = minutes >= 10 ? minutes : "0" + minutes;
  let seconds = curTime.getSeconds();
  seconds = seconds >= 10 ? seconds : "0" + seconds;
  if (timeFormat == timeFormats[0])
    hours = hours > 12 ? hours - 12 : hours == 0 ? 12 : hours;
  let timeString = "";
  if (format == 0) {
    timeString = hours + ":" + minutes;
  } else if (format == 1) {
    timeString = hours + ":" + minutes + ":" + seconds;
  } else if (format == 2) {
    if (timeFormat == timeFormats[0]) {
      timeString = hours;
    } else {
      timeString = hours + ":" + minutes;
    }
  }
  if (timeFormat == timeFormats[0]) {
    if (!graph) timeString += " ";
    timeString += meridiem;
  }

  return timeString;
}

/**
 *@Summary Formats Date and returns as a string
 *
 * @param curDate the date to format
 * @param format - Determine the info to be included in the formatted string. 0 - Entire date, 1 - Day and Month, 2 - Month and Year
 *
 * @return formatted string
 * */
function formatDate(curDate, format, graph) {
  let dateFormat; //= store.getState().userStore.settings.appearance.dateFormat
  if (dateFormat == undefined) dateFormat = dateFormats[0];
  let month = curDate.getMonth();
  let date = curDate.getDate();
  let year = curDate.getFullYear();
  let dateString = "";
  switch (dateFormat) {
    case dateFormats[0]: //"M/D/YY"
    default:
      if (format == 0) {
        dateString = month + 1 + "/" + date + "/" + (year % 100);
      } else if (format == 1) {
        dateString = month + 1 + "/" + date;
      } else if (format == 2) {
        dateString = month + 1 + "/" + (year % 100);
      }
      break;
    case dateFormats[1]: //"D/M/YY"
      if (format == 0) {
        dateString = date + "/" + (month + 1) + "/" + (year % 100);
      } else if (format == 1) {
        dateString = date + "/" + (month + 1);
      } else if (format == 2) {
        dateString = month + 1 + "/" + (year % 100);
      }
      break;
    case dateFormats[2]: //"YY/M/D"
      if (format == 0) {
        dateString = (year % 100) + "/" + (month + 1) + "/" + date;
      } else if (format == 1) {
        dateString = month + 1 + "/" + date;
      } else if (format == 2) {
        dateString = (year % 100) + "/" + (month + 1);
      }
      break;
    case dateFormats[3]: //"Mon,D,Year"
      if (format == 0) {
        dateString = months[month] + " " + date + ", " + year;
        if (graph) dateString = month + 1 + "/" + date + "/" + (year % 100);
      } else if (format == 1) {
        dateString = months[month] + " " + date;
        if (graph) dateString = month + 1 + "/" + date;
      } else if (format == 2) {
        dateString = months[month] + " " + year;
        if (graph) dateString = month + 1 + "/" + (year % 100);
      }
      break;
  }

  return dateString;
}

const delayMs = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export default {
  useMergeState,
  in200s,
  getEpoch,
  limitData,
  normalizeData,
  convertData,
  maxMin,
  compareMaps,
  isCloudConnected,
  isLeapYear,
  formatDate,
  formatTime,
  delayMs,
};
